import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AutocompleteKeyvalueComponent } from '../../../shared-components/inputDataTypes/autocomplete-keyvalue/autocomplete-keyvalue.component';
import { CreatingComponent } from '../../../shared-classes/CreatingComponent';
import { NavigationHelpers } from '../../../common/utils';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { StateService } from '../../../@core/utils';
import { ApiService } from '../../../services/api/api.service';
import { DevicesService } from '../../../services/devices/devices.service';
import { NgIf, NgFor, NgSwitch, CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { NbCardModule, NbPopoverModule, NbInputModule, NbDatepickerModule, NbSelectModule, NbOptionModule, NbToggleModule, NbIconModule, NbButtonModule, NbSpinnerModule, NbAutocompleteModule, NbFormFieldModule, NbAutocompleteComponent } from '@nebular/theme';
import { NgLetModule } from 'ng-let';
import { StandardInputComponent } from '../../../shared-components/inputDataTypes/standard/standard-input.component';
import { entryProp } from '../../../interfaces/apiCalls';
import { allAddressFields, getAddressSchema, LocationAddress } from './address-FE-schema';
import { GoogleMapsModule } from '@angular/google-maps'; // API spec: https://github.com/angular/components/tree/main/src/google-maps#readme
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AddressComponent, GcloudLocationDetailResponse, GcloudLocationSearchResponse, Geometry, PlacePrediction, QueryPrediction, Suggestions } from './mapsTypes';


@Component({
  selector: 'address-search',
  standalone: true,
  imports: [NbFormFieldModule, NbInputModule, AutocompleteKeyvalueComponent, NgIf, NbCardModule, FormsModule, ReactiveFormsModule, NgFor, NbPopoverModule, NgSwitch, NbInputModule, NbDatepickerModule, NbSelectModule, NbOptionModule, NbToggleModule, NbIconModule, NbButtonModule, MatRippleModule, NbSpinnerModule, NbAutocompleteModule, CommonModule, NbDateFnsDateModule, NgLetModule, StandardInputComponent, GoogleMapsModule],
  templateUrl: './address-search.component.html',
  styleUrl: './address-search.component.scss',
})
export class AddressSearchComponent extends CreatingComponent implements AfterViewInit, OnInit {

  // Define an input as a Signal
  context = input<"create" | "edit" | undefined>();
  existingAddress = input<LocationAddress>();

  @Output() locationAddress = new EventEmitter<LocationAddress>();

  @ViewChild('dateAll', {static : true}) dateAny:TemplateRef<any>
  @ViewChild('options', {static : true}) optionsSelect:TemplateRef<any> // custom var name, but not needed anyway? original: options
  @ViewChild('defaultInputTemplate', {static : true}) defaultInputTemplate:TemplateRef<any>
  @ViewChild('autocompleteKeyValue', {static : true}) autocompleteKeyValue:TemplateRef<any>
  @ViewChild('mapContainer') mapContainer!: ElementRef<HTMLDivElement>;
  private resizeObserver!: ResizeObserver;
  @ViewChild('autoInput') autoInputRef: ElementRef<HTMLElement>;
  @ViewChild('auto') autocompleteRef: NbAutocompleteComponent<any>;

  @HostListener('window:resize', ['$event'])

  onResize(event?) {
    // console.log("WINDOW SIZE", window.innerHeight, window.innerWidth)
    //  this.screenHeight = window.innerHeight;
    //  this.screenWidth = window.innerWidth;
  }

  //necessary proxy-trick
  currentSearchInput = {
    input: "",
  };
 
  currentSearchInputUpdate = new Subject<string>();
  searchSessionToken: string = this.renewSearchSessionToken() // for reducing the costs for searches, one search session is valid until location details were fetched.
  handler1 = {
    set : function(obj, prop, value) {
      if (prop === "input" && typeof value === "object" && value !== null) {
        //@ts-ignore
        Reflect.set(obj, prop, value.label);
        // reopen suggestions only if a suggestion was selected, not a real location
        if(!value.placeId){
          this.selectInput();
        }
        return true;
      } else {
        //@ts-ignore
        return Reflect.set(...arguments);
      }
    }.bind(this)
  };
  currentSearchInputProxy = new Proxy(this.currentSearchInput, this.handler1);
  groups: Suggestions;
  filteredGroups$: Observable<Suggestions>;
  inputFormControl: FormControl;
  suggestionSelected : boolean = false; // used to expand the search field if a suggestion was selected
  currentAddress: LocationAddress; // keeping track of it, in case the user wants to modify it.

  mapCenterDefault: {lat: number, lng: number} = { lat: 49.6106, lng: 6.1328 }; // Luxemburg
  mapPinPosition: {lat?: number, lng?: number} = {}

  mapWidth = "400"; // needs to be a string !
  mapHeight = "400";
  entry : entryProp[] // treating the date like an entry
  showMap = true;
  // doc: https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
  // mapOptions : MapOptions = {
  mapOptions : google.maps.MapOptions = {
    fullscreenControl: false,
    streetViewControl: false,
    mapTypeControl: false,
    // style from chrome-extension://fiabciakcmgepblmdkmemdbbkilneeeh/park.html?title=blue%20-%20Snazzy%20Maps%20-%20Free%20Styles%20for%20Google%20Maps&url=https%3A%2F%2Fsnazzymaps.com%2Fstyle%2F1927%2Fblue&tabId=621459504&sessionId=1739043647567&icon=data%3Aimage%2Fpng%3Bbase64%2CiVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAEqpJREFUeF7lm8tvXEd2xn%2Bnbj%2FYbD5EU9SDkixZlmXrYcuLbCYIEHsRBJNMlvJugKyc1SwCZG%2F6L8higATxIgiQnbXMIIPJZpxNAgRZ6GFJsExZEl%2BiSFF8s9nd99aJTtVtstUSyaZkyQlSQLlkieyu%2B9Wpc77znXOFlx2qAlccV24ljOBgpo9MDoEeBlv9EZBjKMeAYwhvAdW2Wez46iawvjWVJ8A0wjToNLhZ0DmQRyS2jq4xj%2Bfy%2BQwue0T0ZR5FXuaXwu%2F8PwZAMKy%2FGUtYmynR1yiR9BfJskHUHyYzC7DJYYQjqB5BnP3dEFABeuOqHRYgZgE1YCOusoj6R4jMoswCj%2BLpyyPEPSJJlslWm6yVGvSNNvhkLCMe574sYX8WoAhfjglfAP%2B5XGa11k%2FB9%2BO0H3XDeI4i%2FgjKUVRGgLcQhtCw9qGUgTJCCSh0WF%2BK0gDqCHWUNYQnKIvAE0TnER6ibhbHQ8Qv4GWV1K3SX1nlZ4N1vnz6%2BF%2BM2S67BmE%2FAAhjY8L5m8LIBSGdqeI4iHAQbOphvN15HQUZBR1GpIrSh1BF6IkPLQXQAmp%2Bo20IHiQFTQEDYxNlHWEN1XWQBdAZRGZw5hPkEfAY5TGexxRG15m%2Fqdy6oIyNGQBdgdA9AIYrY8I3OPpnhFUGUTlGpsdJOIbneO7sjqPhzwcgnLSZuq0JhIe272zNdgham7bVAxkEi7CrYesSwhTKVHCOjikypklkCtFp%2BllmdVT5xH63eyvYBwBjjt8uFEmWCrhKgZJ%2Fi6Y7hcgpxJ9C5UQwfeEo6Cgq%2FVsPKltGaQ%2FVmp0nZHsxkOK0%2F9NwinGKroLMoGb%2BNnUSdfdRvU%2FR36fhnuBrKdmBlJ8PN5ExA3HP0T0A%2F%2F15kblyBc16KTQq4A5RkNOgp1FOA6PAcJgW8jQ4vPw01dYmiDm5zdzZmam3D%2FMJ9js9oLYWQWx%2F0WqEGjE0LuRzBuEHkB9I9Qfwc6SlGpJscKhe4w%2B%2BMsvZc3QPwL%2F%2BqkzSHER0EMz8OYrTM4ieQcVWi%2Ft9QGvaA8X7HGcNdAWVFURXgrN7dpRRGUB0AGQgB8M%2BozXtM9bi1DVUZhEdR2UcL%2BPBKmAZlWWy4jJ%2F9uvOz38hGN0D8C%2Bf99LDweD4Mg6i%2FgTiziKcBc7idASV7Ttvnli1AWIe3Tz7anBadoISnJeFu%2B0h9KLBoZoVHUTpRyxqaBmRkl2CLZ8g2sDLPHAHtenvIG6SJHeImzzmL7569vN3sIW9ANgOKL%2F9VT896VEyPQrezP1tRM6AvofqGRAz%2FWiu0cM%2FvYfhoddiSNNFVOaAOJ3aaW4PH6znUJiih1AZCqHTLMrAsCsRIkXwDB50AZFxkO9RHQcmwM2QyEM2Cw%2F5%2Ba%2Ftu6O73SUi7AZAW9ibF7ILg0jzJJmexLm3UT2J8DZwMv5ZzOu3hoGwgTAfwpSdvMVxZA61NVBao71tQ6uBQovxhwCA8YgYZpURzELaH0R1CZEHwAOUifBn7ydI5AFafEByc5n5kT3D4s4AmMlduexCzJ%2B%2F6RgYGqbgz6BJvPfBAjiK11FEjuZ3P3rs6N%2BXESZD2LI1kBjmAxBmvq7jCnh682tkDzsSyRQnECysngh%2BJ%2B62FUKNHzzE5ZHBLMD8gWTjpG6clcUFRi74wA0uX%2FE7kaPdAfjmk4T5EcdI1ZGW7HTOo3oOJ%2BfwZgkM5%2FfWTqkSTNTM00mGqnnr78MUM1M%2FhXN2bx%2Bj8piaPHtHK9qLaCRV3o8g7jiq7wFxigzj1cKjC1fMokKwrHDvF3BmAXobkduo3qLQmGN%2B3TMy7%2FnkG6PJLyRGOwMwNub4xUxCY7HAfH%2BBij9CUryI8iHIxWD%2BygFEBlFtkZ4MEWNxGaLG3W%2Bhehu4Fe%2BoX6DBEw70L%2FCHf2sPsD3%2B468rLK0OU7Ks0ZkjtOt1HpFzoOdRsdwiQdWignGFBiJLqJqlLYVrgH6LcIOs%2BS01N8vIakppKOU3oxljL%2BYFOwPw9eWEkWqRFVekLOaARikUPowA6EcQzNI8dX9wUhqclMXeJiJNVC19vYnKt2FjzhtxWQJdJkmX%2BfSfjA9sj9%2F%2FZQ9ZYRBkEPEH8O5EBFovglxAxBIrY5XFre8yJ6vB0dqcBLkeAEjTGygz1LXJgG8yv97ksytGwJ4bu1yBywm%2FGSojiYWhMoXGMVzyEY6PUL0EchzMcQXnZKt5fqOsjZDUCDOAbeQ6IjdI%2FSSZXyNhlRMra1y4Yj%2B7PW5eLjE50EdGP4nro%2BBOoPohgoFtwI%2FmSZSFWpsWEcyRbkSHqlOIXMNzHZ9dJy1No1pHszq%2FWKwj%2BwXg92MFViYqFKs9FOsVvB7HySUEmx8Hvm9xWo25iSU65v9aMd9Odxq4BlxFuUbqpiimNRq1GpPVGn%2FVwdT%2B4fMiJ9YrlCoVmoUKBW%2Bffwn4GMJq4kpP5AZiWaV93yYSkibjGZYnxO%2Fyeg0nUzTLNZrrmwy8XePTsU7mueVRX2QZ0El9C4mdyMfx4cU2dQzUTsI2UwJTZN4kAKZI5ekzYtY0jagBcBWRq6TZZDfUeOcrYAAs0kuZXpr0hjvpvJ28PXwOgN17Y2kBCBtv8gpYqtCIbDP4HrO4qwhX8e5q8DlFNqizwRAbO%2BUGuwOw2qjie6pk2gvp27jCpS0rCMmPFHMrMMdkCcubdIKtBKsBat9rmWI8fZ9eg4KRog3c5jr9pfX9A%2FD15RK9B6tUm1XUV%2FHOqO%2BlYAFxNbGz5ZEtNBmYbzIMGuFKt0HHnN61YAG2Oj%2BBuHXWi%2BtsPF7nsw6nm5vsbmEwAuCaVcRXKSYWltqckh6LFhAED5sOJAM172zTKPCPR4SC6hS%2Bw4EaD7DvsHyjiYZp6XF8eFtdNvlqALR8QEYvRfMBlv3lAEQrsIQod4AhLFkYjMmKrZpTYWQyhqgOKpx1UOHkBVQ4hloTWowSWxreUpRa3xV9joTQa2E3%2BgCLBEk2SVM3kML6y%2FmAF4Ulc37bocmuQBQ5LSyJJtsKjlgqvJ0MicQcoJUMic7hOwBwlg53JEOqlhfkyZD0QvD85muM2BrYLQE1RoEAgFxFs6tkTJGwQaNS200g2fkKGA9grgfSHvA9pJaUyMckRD%2BA6X4h%2FrdmIWxrm3GbIJELGKwibKfDatmgCZ3tQ6qIFVRa6TAmo1sa3BJYYuyPUpnkAuo271ADQK4iPo8EMkW5XMOtb9J8GR6g7UywVqanZF7fHv4SeGOCZpq9eZpqbLBT5zeF10CIU2QlJEiWHu8miNiJW%2BKjpgy1WZgpyc%2FgFe69kaBaTIzCVdt2gj6bpk82WW3UKb1b3z8RauUCRVdkTYqU3FFS%2FQgnH4L7ENETeAZCLhBPKmdnW7s07r3tpIQNlBUIQKwE7b99WM1ATApT%2B8yBHNwYZSK45vjah5m9yeVRNpcAwHXEXUNs1WlSmlSrDaamGvvPBbaywWqB%2BeUCAz2HydKLqF5E5ELM1qzaE4QQM9ecDm%2Ft0XLwLGSGITwGR2UnZvTVMsHnRdGYUhvd7UFzKT1kgFuSejsAdv9XAqgxIZrAyXW83KDgr9PPQxYGUrL6rirx3oLI6SHHYNkxkx0i8%2BfDFM6DngTZ1vBiUrQ9oj%2FIZe1Ak1vhsRtZvBXu2p1e514t31iCUDmK6bDjBl6%2BRdwNDhyeZXAhY2o449%2BfOsx9p8PmbtorQdw%2FiC%2Bfxfv3wcTQAEBe%2B5PD4PuDh9pyUi9OMX7EvzVBJYqs6GMwKYxbJC7O9WSOQ3XPD4v%2B5RShkGxZ2PnyqTRm5bAhM%2FdTeH0H5R1UTgY%2FEGN0lKxaclUMU3sJrq%2BKhYmts4gVTk17CPrgHZx%2BR0Hu0MvjbipFu28yPIQ%2BxeBL4Y%2FvD1AvHsPJMUQsEzwJVhDR0yCn8%2Fq%2FEZTWfN0AWG1hKnp%2Fb6tZwF0S7rLZ%2FIG1tSdcflon5AvdrXeg200Kv%2FubXlg6FCpCiY7ggwW8D%2FI%2Bwvu5cpuXtoyqhqrOaxy6BHIP4V4ojwk2H4B7wIab4M%2F%2F3vxDFOl3Gd1v0iSremkIL0OU%2FQE0KDbnIGh254AjQReIpe9WMfTHA%2BB5p2plsnHQccR9D%2F4BmZ%2BhmExTTKf5o3%2BMdYE9RvcAPCdZhQLoB4jY6X%2BQ1wZjKTyyt5ZGsNceuv33zrBqDTLxzqt8R6IP8MkcaToP9Tn%2B9J87mOaLv6Z7AFrUeC3tIfE9JBymkJzF2zVQK5EdR2QIVVN1h%2FICZ7cP183PPUusQscIUXV27hYiExR0EXSR2cUlPrvyrOq8wzd0D4ARo%2FM3C1g3gMnkPe4g4t7D%2BfdATLt%2FGywc0ppmBT%2FiCM0T29SaUAy9geq3JMkNyKYoySouW2PwxBoXxp4VXV8ZgHZesDjkOFUbolCyvoB3UPdOXimyxohWg4RVctrT1%2B7BfvFmmzGBCiW1dSz5MQncACgUbpBmM90kP50fvZ9NCaHMn%2FOC3uIAPf1HQ19QKJaq6QWnEAwUW60trlUtfhGX3691GPMzEzfvv4jqFE5uIe42mb9NuTxLvd7Yi%2Fu%2FCgB5Gprzgp%2FdreAqlrW9RWL33vqDXN4vEGqH1i9ojQ6t2dkUtV8A7OTnUOaQUGGeCMQHuQPuDj31edxgytRUxq0L6U7U99UAiL8drebmWJEnj6psbPZBsUoSipkfIHwQVscoqkaPY3k7hsdXGTnx0WlEpvA8QOQucJdM7lI68uT1Nkl1bt3S5cpQmb7eEtmapcKHIbEc4X08Ro7MH9g1sEzRVrOEVmW3m6sXkykR6wWwu2fmfx%2FlPo57gfkJE2TBEib4k6%2BWXwbdbjby4s%2FVvGmqkhWhVMBvDJPJKRzbTVOWLOGPhqQJTOBoFzX3ouEW903utmKrqb%2BW8IzjdJzMKK9OQDJLo%2Fko3P9P%2F%2B7Zhosu0XgFAFT45suE2kJCVk%2FoKwzg09HoFK1nwB0Hb11k1kBxKucG7T0%2Fz%2FYJPrfhPOzFspc5QIv73yF8B%2FId6qbIdBEpPKGvuPhctfm1AxBYdltUGO3vpVkaRtPh0DVqPUSWNhPyBesjOvRMIeV5hadzyyZ5mbC6HgVWMdn7Ziy1%2B1tIcRpprlMorvNwZ91%2FLxxe3gI6P9m6yFgboNTTj08H8ozxXHCK4swxmmXkfcJBPOnsFo%2BJS0hd7D9ipx5r%2Fz6s1hB5Gy%2B3IYS%2BWcjqiGl%2Bk3U%2B%2FeaFxc83B0B7HaGQVJDU7v1Z1Fiing1hMnaPWlPFATT0Am6PZ5KdgIDd6dhQFUKfTKL%2BLo7xkPam%2FnE39f83B4BFhePHS6yvl2g2SxQTU3ffxclpPO8GFbnVRR7psiVN7RbYapFtSWfWTBHzfVUTPCeRJHp84%2F3p%2BhKlJONOKePhzh0gbw6AVlOVaYhzZUclGyJtxFZaY4YutNTEua0gbfOK4FCstLYlpFo%2FobW%2F3cVbG5xO4Nws6mcppA%2Fh%2Flo3XWBvDoDnfcIApUZsoA7N06Gt7t2oIgWLeAvVVhvs85UeMa%2BvOdPjDuLNAhaQbIE196TbRsifDoDf%2FbIK5UMUnfX8HULVmp7MF5xF1YjSCEgSCp2KVZUs5ltD9ApYY3SoJVoL7Pd4P45YS1yyQr25An0r3bbC%2FnQAmIJE7wHSxhCSHIhhUc7HFjvr%2Fgq9xbGV3hosYqyPTZXWRmfvCQl3weiu%2FwGxZuhijWqjtlupa68H7vz3Hy8Mdn6yRYXQYOGrZBVrgrTr8GGc8lEgS1t1RbFeI2umzl%2BSCoVOc3b3cHKPTe7T31h4mWRnL0BeHwC%2F%2F6RA40QZLZUhKVPyo2RWW5RLOPkoNlho6xUaqzCvon4iqrv6gMQ6P7Hmykl8bYrk9PLLJDs%2FHQCt2mKtWaJSLZHayxTWXxge3lrfjoTGx%2BAHQgPkSjhtU3gt4VGdpliYw2fz1MvzrM2udyNz7%2FXAb%2B4KWLJ062aB2lCBRYok6RF8Mb8Coe%2FP3i00KhB1ezU9L38Bwvt7iL0nyDIuW6G3f4V%2FG6zzxRcWKveUuvcDwuu7AlZVak%2BWSt5E1Iuot%2BLqxdgTbC9ISavPx94hiE7Psr3QUV6tI0mdUp%2BVt40jdPUi1P8SAPJucyNGq40E1ztCmp7DW3HVnYt02G%2FmnD9GAK%2F3wyxX7tEoL1J6%2FMpMby8wXrMFfJpwaMSxTEJ9cJiUMzh3Jn%2FBoi8XOfMXKuzdQIv9fpZG5SGV1dXQ7W3M8PLXL%2F1q7E8MQJte0Ls5BOX4wkUiJqH3hCwPv4yzrm9ZwusiiV%2Bk3rvIZL3G0KIP7wHu82XIvR762RxsPz%2B9n59tNViY%2BTeyhEplgNSbTjiKJqYiJ%2BAWQgu9Jgs4v0KW1ij6DWr9Nf5ruPk6nN6biwLtALyVJSxXBsJ7xWqZoB4mFYd1j7lsnoLM490qlXKDidn4ouQO7e37OYNufvb1%2BYD%2FIwD8D8YUm8j6JoZ9AAAAAElFTkSuQmCC
    styles: [
      {
          "featureType": "administrative",
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "color": "#444444"
              }
          ]
      },
      {
          "featureType": "landscape",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#f2f2f2"
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "road",
          "elementType": "all",
          "stylers": [
              {
                  "saturation": -100
              },
              {
                  "lightness": 45
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "simplified"
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "transit",
          "elementType": "all",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "water",
          "elementType": "all",
          "stylers": [
              {
                  "color": "#46bcec"
              },
              {
                  "visibility": "on"
              }
          ]
      }
  ],
  }

// blue pin, a little oldschool
  /* theIcon : google.maps.Icon = {
    url: 'https://maps.google.com/mapfiles/kml/pushpin/blue-pushpin.png',
    scaledSize: new google.maps.Size(40, 40)
  } */

  markerOptions: google.maps.MarkerOptions = {
  icon: {
      path: google.maps.SymbolPath.BACKWARD_OPEN_ARROW,
      fillColor: "#3366ff",
      fillOpacity: 1,
      strokeWeight: 0,
      scale: 8
    },
   /*  icon: {
      url: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
      scaledSize: new google.maps.Size(40, 40)
    }, */
    draggable: true,
    animation: google.maps.Animation.DROP,
    // position: this.mapPinPosition, // defined by separate variable
  }


  constructor(
       public state: StateService,
        public fb: FormBuilder,
        public api: ApiService,
        public navigate: NavigationHelpers,
        public translate: TranslateService,
        public devices: DevicesService
  ) { 
    super({fb, api, devices, dataType: "user", translate}); // risky: passing dataType = user just to satisfy type checker. it is not used though.
        // due to async operations needed, the form is initialised in here:
        this.entry = getAddressSchema(this.translate)

        // create the form......
        this.createForm(this.entryForm, this.fb, state, this.entry)
        this.setupSearchInputListener()
          
  }

  setMapSize(height: number, width: number) {
    this.mapWidth = `${width}px`;
  }

  setupSearchInputListener() {
    this.currentSearchInputUpdate
    .pipe(
    debounceTime(200),
    distinctUntilChanged())
    .subscribe(event => {
    console.devlog('search input value', this.currentSearchInput.input);
    this.suggestionSelected = false;
    this.searchLocation(this.currentSearchInput.input);
    });
  }
    
  fillAddressFormWithExistingAddress(){
    this.entryForm.patchValue(this.existingAddress());
  }
    
  ngOnInit(): void {
    console.devlog("existingAddress", this.existingAddress());
    
    if(this.existingAddress() && this.existingAddress().gpsLng && this.existingAddress().gpsLat){
      this.mapPinPosition.lat = Number(this.existingAddress().gpsLat);
       this.mapPinPosition.lng = Number(this.existingAddress().gpsLng);
    }
    
    console.devlog("predefinedAddress:", this.existingAddress());
    
    this.fillAddressFormWithExistingAddress()
    console.devlog("this.entryForm.", this.entryForm)  
    this.groups = [
      // put search predictions here
      {
        name: this.translate.instant('address.suggestions'),
        children: [],
      },
      // put place predictions here
      {
        name: this.translate.instant('address.places'),
        children: [],
      },
      ];


    this.filteredGroups$ = of(this.groups);
    this.inputFormControl = new FormControl();      
    this.entryForm.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()).subscribe( async (value) => {
      console.devlog("value changes", value);

      const someAddress = Object.entries(value)
        .filter(([key]) => key !== "gpsLat" && key !== "gpsLng") // Exclude gpsLat and gpsLng
        .map(([, value]) => value) // Get the values
        .filter(value => value) // Remove empty strings
        .join(", "); // Concatenate with a comma

      console.devlog("value changes someAddress", someAddress);

    let result = await this.api.getGPSforAddress(someAddress)
    if(result.message && result.message.status === "OK") {
      console.devlog("GPS", result.message.results[0].geometry.location);
      let foundGps = result.message.results[0].geometry.location
      this.mapPinPosition = foundGps;

      //SET THE NEW GPS VALUES TO THE FORM
      this.entryForm.controls["gpsLat"].setValue(foundGps.lat, {emitEvent: false});
      this.entryForm.controls["gpsLng"].setValue(foundGps.lng, {emitEvent: false});


      //report final address from manual change:
      value.gpsLat = foundGps.lat;
      value.gpsLng = foundGps.lng;
      this.checkAddressAndReturnOutput(value);
    }

    }
    );
  }

  private filterChildren(children: string[], filterValue: string) {
    return children.filter(optionValue => optionValue.toLowerCase().includes(filterValue));
  }

  trackByFn(index, item) {
    return item.name;
  }
  
  ngAfterViewInit() {
    if (this.mapContainer) {
      this.resizeObserver = new ResizeObserver(entries => {
        for (let entry of entries) {
          const width = Math.floor(entry.contentRect.width);
          const height = Math.floor(entry.contentRect.height);
          this.handleResize(width, height);
        }
      });

      this.resizeObserver.observe(this.mapContainer.nativeElement);
    }
  }

  ngOnDestroy() {
    this.currentSearchInputUpdate.unsubscribe();

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }
// map view
  handleResize(width: number, height: number) {

    if(window.screen.width < 576){
      this.mapWidth = width.toString(); ;
    } else {
      // Custom logic for handling size changes
      this.mapWidth = `${width - 15}`;
    }

    this.mapHeight = height.toString();
  }

  handleOnEnter($event) {
    console.devlog("enter", $event);
    if($event && $event.placeId) {
      this.getLocationDetails($event.placeId);
    }
  }

  onSelection(option: PlacePrediction | QueryPrediction) {
    console.devlog("option selected", option);
    // this.currentSearchInput = option.label;
    this.suggestionSelected = true;

    if((option as PlacePrediction).placeId){
      this.getLocationDetails((option as PlacePrediction).placeId);
    }
  }

  async searchLocation(input: string) {
    if (this.currentSearchInput.input.length < 1) {
      this.groups[0].children = [];
      this.groups[1].children = [];
      return
    }

    let result : GcloudLocationSearchResponse
    result = await this.api.searchPlaces(this.currentSearchInput.input, this.searchSessionToken);
    console.devlog("search result", result);
     // process results
    if(result.suggestions && result.suggestions.length > 0) {
      this.groups[0].children = [];
      this.groups[1].children = [];

      // separate the results into two groups
      result.suggestions.forEach(element => {
        if(element.queryPrediction) {

           this.groups[0].children.push({label: element.queryPrediction.text.text, ...element.queryPrediction}) 
          } else {
           this.groups[1].children.push({label: element.placePrediction.text.text, ...element.placePrediction})
          };
      });
    
    }
    
  }

  async getLocationDetails(placeId: string) {
    let response : {message:  GcloudLocationDetailResponse} = await this.api.getPlaceDetails(placeId, this.searchSessionToken);
    this.renewSearchSessionToken();
    console.devlog("Location Details", response.message);
    this.mapPinPosition = response.message.result.geometry.location;
    this.processAddressAndReturnOutput(response.message.result);
  }

  // both for initiation and refreshing the token
  renewSearchSessionToken() {
    this.searchSessionToken = (Date.now() * Math.random()).toString().replace(".", "");
    return this.searchSessionToken = (Date.now() * Math.random()).toString().replace(".", "");;

  }

  onSelectionChange($event) {
    console.devlog("selection changed", $event);
    /* this.filteredOptions$ = this.getFilteredOptions($event); */
  }

  selectInput() {
    if (this.autoInputRef) {
      const inputElement = this.autoInputRef.nativeElement;
      setTimeout(() => { // accounting for the loop...
        this.autoInputRef.nativeElement.click();
      }, 0)
    }
  }

  test($event){
    console.devlog("enter test:", $event);
  }

  processAddressAndReturnOutput({ address_components, geometry }: { address_components: AddressComponent[], geometry: Geometry }) {
    // GPS coordinates are just passed along and not evaluated in any form.
    let zipCode = '';
    let street = '';
    let city = '';
    let streetNumber = '';
    let country = '';
    let gpsLat = geometry.location.lat
    let gpsLng = geometry.location.lng;

    address_components.forEach(component => {
      // get street name
      if (component.types.includes('route')) {
        street = component.long_name;
      }

      // get city name
      if (component.types.includes('locality')) {
        city = component.long_name;
      }

      // get zip code
      if (component.types.includes('postal_code')) {
        zipCode = component.short_name;
      }

      // get street number
      if (component.types.includes('street_number')) {
        streetNumber = component.long_name;
      }

      // get country
      if (component.types.includes('country')) {
        country = component.short_name;
      }


    });

    //return { zipCode, street, city, streetNumber, country };
    this.entryForm.controls["street"].setValue(street, {emitEvent: false});
    this.entryForm.controls["streetNumber"].setValue(streetNumber, {emitEvent: false});
    this.entryForm.controls["city"].setValue(city, {emitEvent: false});
    this.entryForm.controls["zipCode"].setValue(zipCode, {emitEvent: false});
    this.entryForm.controls["country"].setValue(country, {emitEvent: false});
    // this.entryForm.updateValueAndValidity();

    allAddressFields.forEach(field  => {
      //bypass read-only to change 'pristine' status so highlighint of the input forms is correct
      let what = "pristine";
      this.entryForm.controls[field][what] = false;
      this.checkValidity(field);
    });


    let locationAddress : LocationAddress = {
      street,
      streetNumber,
      city,
      zipCode,
      country,
      gpsLat,
      gpsLng,
    }

    this.checkAddressAndReturnOutput(locationAddress);
  }

  checkAddressAndReturnOutput(locationAddress: LocationAddress){
      //check for completenes, then 
      if (this.checkAddress(locationAddress)){
        console.devlog("typia locationAddress", locationAddress);
        this.currentAddress = locationAddress;
        this.locationAddress.next(locationAddress);
      }
  }

// hardcode check function previously generated by typia
  checkAddress = (input) => {
  const _io0 = (input) =>
    "string" === typeof input.street &&
    "string" === typeof input.streetNumber &&
    "string" === typeof input.city &&
    "string" === typeof input.zipCode &&
    "string" === typeof input.country &&
    "number" === typeof input.gpsLat &&
    "number" === typeof input.gpsLng;
    return (input) => "object" === typeof input && null !== input && _io0(input);
  }
}



export interface addressDataReceiver {
  receiveAddressData(addressData: any): void;
}
